import type { CatalogRatioGroupData, CatalogUerBaseCostData } from '@gql/graphql';
import { RatioTypeEnum } from '@gql/graphql';

import { useMemo } from 'react';

type TUseMassApplicationBaseCostsOutputData = {
    responseRatioType?: RatioTypeEnum;
    selectedRatioGroup: CatalogRatioGroupData | null;
    baseCostsData: CatalogUerBaseCostData[];
    selectedSubgroup: CatalogRatioGroupData | null;
};

export const useMassApplicationBaseCostsOutputData = ({
    responseRatioType,
    selectedRatioGroup,
    baseCostsData,
    selectedSubgroup,
}: TUseMassApplicationBaseCostsOutputData) => {
    const selectedRatioGroupId = selectedRatioGroup?.id;

    const currentBaseCostsRowData = useMemo(() => {
        if (!Array.isArray(baseCostsData)) {
            return [];
        }

        return baseCostsData;
    }, [baseCostsData]);

    const updateGroupBaseCostsRowData = useMemo(() => {
        if (!currentBaseCostsRowData || !Array.isArray(currentBaseCostsRowData)) {
            return [];
        }

        const hasNewObj = currentBaseCostsRowData.some((item) => item);

        if (hasNewObj && responseRatioType !== RatioTypeEnum.TechPartCoef) {
            const rowGroup = {
                id: selectedSubgroup ? selectedSubgroup.id : selectedRatioGroupId,
                sectionName: selectedSubgroup ? selectedSubgroup.name : selectedRatioGroup?.name,
                groupRow: true,
            };

            return [rowGroup, ...currentBaseCostsRowData];
        }

        return currentBaseCostsRowData;
    }, [currentBaseCostsRowData, responseRatioType, selectedRatioGroup?.name, selectedRatioGroupId, selectedSubgroup]);

    return useMemo(
        () => ({ currentBaseCostsRowData, updateGroupBaseCostsRowData }),
        [currentBaseCostsRowData, updateGroupBaseCostsRowData],
    );
};
